import axios from "axios";

export default {
    getAll() {
        let tokenAuth = localStorage.getItem("access_token");
        let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

        return axios
            .get("api/sucursales", headerAuth)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                console.log(e);
                throw e;
            });
    },

    getAllForDrop() {
        let tokenAuth = localStorage.getItem("access_token");
        let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

        return axios
            .get("api/sucursales-drop", headerAuth)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                console.log(e);
                throw e;
            });
    },

    get(id) {
        let tokenAuth = localStorage.getItem("access_token");
        let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

        return axios
            .get(`api/sucursal/${id}`, headerAuth)
            .then((result) => {
                let fechaApertura = result.data.fechaApertura;
                result.data.fechaApertura = fechaApertura.substr(0, 10);
                return result.data;
            })
            .catch((e) => {
                console.log(e);
                throw e;
            });
    },

    add(sucursal) {
        let tokenAuth = localStorage.getItem("access_token");
        let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

        return axios
            .post("api/sucursal", sucursal, headerAuth)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                console.log(e);
                throw e;
            });
    },

    update(sucursal) {
        let tokenAuth = localStorage.getItem("access_token");
        let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

        return axios
            .put(`api/sucursal/${sucursal.sucursalId}`, sucursal, headerAuth)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                console.log(e);
                throw e;
            });
    },

    delete(id) {
        let tokenAuth = localStorage.getItem("access_token");
        let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

        return axios
            .delete(`api/sucursal/${id}`, headerAuth)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                console.log(e);
                throw e;
            });
    },

    getFolioRenta(id) {
        let tokenAuth = localStorage.getItem("access_token");
        let headerAuth = { headers: { Authorization: `${tokenAuth}` } };

        return axios
            .get(`api/sucursal/folio-renta/${id}`, headerAuth)
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                console.log(e);
                throw e;
            });
    },

    getAllPublic() {
        let token = localStorage.getItem("tokenAcceso");
        let usuarioId = localStorage.getItem("usuarioId");

        return axios
            .get(`api/sucursales-public`, {
                params: {
                    usuarioId: usuarioId,
                    token: token
                }
            })
            .then((result) => {
                return result.data;
            })
            .catch((e) => {
                console.log(e);
                throw e;
            });
    },
};